import uuidv4 from 'uuid/v4';

import { reportFeatureFlagToRum } from 'wanderu-analytics';
import {
    fireStructuredSnowplowEvent,
} from 'wanderu-service-analytics';

import type { Cookies } from 'react-cookie';

const SPLIT_TEST_COOKIE_NAME = 'split-test-id';

function fireSplitTestEvent(eventData) {
    if (!eventData || !eventData.property || !eventData.property.treatments
        || !eventData.property.treatments.length) {
        return;
    }

    fireStructuredSnowplowEvent(eventData);

    if (eventData?.action === 'rendered') {
        // Report through wanderu-analytics so the evaluation survives the
        // manual startView that would otherwise clear it. Keep the reference
        // lazy: this package sits on a cycle back through wanderu-analytics.
        const [name, variant] = eventData.label.split(':');
        reportFeatureFlagToRum(name, variant);
    }
}

const COOKIE_OPTIONS = {
    path: '/',
    sameSite: true,
    secure: true,
};

function initializeVisitorId(cookies: Cookies) {
    let visitorId = cookies.get(SPLIT_TEST_COOKIE_NAME);

    if (!visitorId) {
        visitorId = uuidv4();

        const domain = typeof document !== 'undefined'
            ? document.location.hostname
            : undefined; // server.  browser will do the right thing

        cookies.set(SPLIT_TEST_COOKIE_NAME, visitorId, {
            ...COOKIE_OPTIONS,
            domain,
            maxAge: 86400 * 365 * 10 * 1000,
        });
    }

    return visitorId;
}

export {
    SPLIT_TEST_COOKIE_NAME,
    fireSplitTestEvent,
    initializeVisitorId,
};
